module.exports = __webpack_public_path__ + "img/template-wire-1.df17bca8.jpg";